<template>
  <div class="about">
    <div class="info">
      <div class="title">关于华院</div>
      <div class="content">
        华院计算技术（上海）股份有限公司是认知智能领域的开拓者，荣获国家级专精特新“小巨人”企业称号。公司基于非线性期望的小样本学习、知识本体动态融合推理及神经符号认知规划等全栈式专有算法，开发认知智能产品，整合数据与领域知识，服务于工业制造、文化旅游等多个不同行业，使企业优化生产及业务营运，让世界更智慧。
      </div>
    </div>
    <van-tabs
      v-model="active"
      class="tabs"
      @click="handleTabChange"
      id="tabs"
      :class="{ fixedTabs: fixedTabs }"
    >
      <van-tab
        v-for="(item, index) in tabs"
        :key="item"
        :title="item"
        :name="index"
      />
    </van-tabs>
    <a name="about-team" id="about-team">
      <Team />
    </a>
    <a name="about-socialResponsibility" id="about-socialResponsibility">
      <SocialResponsibility />
    </a>
    <a name="about-honour" id="about-honour">
      <Honour />
    </a>
    <a name="about-contactUs" id="about-contactUs" class="about-last-section">
      <ContactUs />
    </a>
  </div>
</template>
<script>
import Team from "./team.vue";
import Honour from "./honour.vue";
import ContactUs from "./contactUs.vue";
import SocialResponsibility from "./socialResponsibility.vue";
export default {
  name: "about",
  components: {
    Team,
    Honour,
    ContactUs,
    SocialResponsibility
  },
  data() {
    return {
      active: 0,
      fixedTabs: false,
      scrollingToTab: false,
      tabs: ["华院团队", "社会责任", "荣誉资质", "联系我们"],
      refs: [
        "about-team",
        "about-socialResponsibility",
        "about-honour",
        "about-contactUs"
      ]
    };
  },
  watch: {
    "$route.query.tab"(tab) {
      if (tab !== undefined) {
        this.$nextTick(() => this.scrollToTab(tab));
      }
    }
  },
  mounted() {
    window.addEventListener("scroll", this.tabScroll);
    if (this.$route.query.tab !== undefined) {
      this.$nextTick(() => {
        requestAnimationFrame(() => this.scrollToTab(this.$route.query.tab));
      });
    }
  },
  methods: {
    handleTabChange(e) {
      this.scrollToTab(e);
    },
    scrollToTab(e) {
      const index = Number(e);
      if (isNaN(index) || index < 0 || index >= this.refs.length) return;

      this.scrollingToTab = true;
      this.active = index;
      const offset = this.getTabOffset();
      const el = document.getElementById(this.refs[index]);
      if (!el) {
        this.scrollingToTab = false;
        return;
      }

      let targetScroll;
      if (index === 0) {
        targetScroll = this.fixedTabs
          ? (632 * this.$el.clientWidth) / 750
          : this.getElementScrollTop(el) - offset;
      } else {
        targetScroll = this.getElementScrollTop(el) - offset;
      }
      document.documentElement.scrollTop = Math.min(
        Math.max(targetScroll, 0),
        this.getMaxScroll()
      );
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.scrollingToTab = false;
          this.tabScroll();
        });
      });
    },
    getElementScrollTop(el) {
      return el.getBoundingClientRect().top + window.pageYOffset;
    },
    getMaxScroll() {
      return Math.max(
        document.documentElement.scrollHeight - window.innerHeight,
        0
      );
    },
    getTabOffset() {
      return (190 * this.$el.clientWidth) / 750;
    },
    getSectionTops() {
      const offset = this.getTabOffset();
      return this.refs.map(id => {
        const el = document.getElementById(id);
        return el ? this.getElementScrollTop(el) - offset : 0;
      });
    },
    tabScroll() {
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      this.fixedTabs = scrollTop > (632 * this.$el.clientWidth) / 750;
      if (this.scrollingToTab) return;

      const maxScroll = this.getMaxScroll();
      // 高屏设备最后一屏内容不足时，滚到底仍激活最后一个 tab
      if (scrollTop >= maxScroll - 2) {
        this.active = this.refs.length - 1;
        return;
      }

      const tops = this.getSectionTops();
      let activeIndex = 0;
      for (let i = tops.length - 1; i >= 0; i--) {
        if (scrollTop >= tops[i] - 1) {
          activeIndex = i;
          break;
        }
      }
      this.active = activeIndex;
    }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.tabScroll);
  }
};
</script>
<style lang="less" scoped>
.about {
  width: 100%;
  padding: 96px 0px;

  .info {
    width: 100%;
    background: url("../../../static/img/about/about_bg.png") no-repeat 0 0 /
      100%;
    overflow: hidden;
    padding-bottom: 44px;

    .title {
      margin-top: 48px;
      font-size: 44px;
      font-weight: 500;
      color: #08204d;
      line-height: 60px;
      text-align: center;
    }

    .content {
      padding: 0 68px;
      font-size: 24px;
      font-weight: 400;
      color: #08204d;
      line-height: 40px;
      margin-top: 24px;
    }
  }

  .tabs {
    height: 94px;

    /deep/.van-tabs__wrap {
      height: 94px;

      .van-tab__text {
        height: 100%;
        font-size: 26px;
        color: #08204d;
        line-height: 94px;
      }

      .van-tabs__line {
        background-color: blue;
      }
    }
  }

  .fixedTabs {
    position: fixed;
    top: 96px;
    width: 100%;
  }

}
</style>



// WEBPACK FOOTER //
// src/view/about/index.vue